import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql, Link } from "gatsby"

import Header from "./header"
import "../../static/styles/main.scss"
import logo from "../../static/images/logo.svg"
import iconTwitter from "../../static/images/icon-twitter.svg"
import iconInstagram from "../../static/images/icon-instagram.svg"
import iconLinkedIn from "../../static/images/icon-linkedin.svg"

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Header siteTitle={data.site.siteMetadata.title} />
        <main>{children}</main>
        <footer>
          <div className={"container"}>
            <div className={"row"}>
              <div className={"col-5"}>
                <div className={"widget__item"}>
                  <div className={"logo"}>
                    <Link to="/" title={"Servit"}>
                      <img alt={"Logo"} src={logo} />
                      <h3>Servit</h3>
                    </Link>
                  </div>
                  <div className={"about"}>
                    <p>
                      Servit is a general company of all services. A Service
                      delivery application that allows you to requests for
                      services right from your couch.
                    </p>
                  </div>
                </div>
              </div>

              <div className={"col-2"}>
                <div className={"widget__item"}>
                  <div className={"links"}>
                    <h4>Support</h4>
                    <ul>
                      <li>
                        <Link to="/privacy" title={"Privacy Policy"}>
                          Privacy
                        </Link>
                      </li>
                      <li>
                        <Link to="/terms" title={"Terms Of Use"}>
                          Terms Of Use
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className={"col-3"}>
                <div className={"widget__item"}>
                  <ul className={"links"}>
                    <h4>Location</h4>
                    <ul>
                      <li>Uyo, AkwaIbom</li>
                      <li>Nigeria</li>
                      <li>
                        <a
                          className={"links__special"}
                          href={""}
                          target={"_blank"}
                          title={
                            "We look forward to receiving your great feedback"
                          }
                        >
                          RC 222132
                        </a>
                      </li>
                    </ul>
                  </ul>
                </div>
              </div>

              <div className={"col-2"}>
                <div className={"widget__item"}>
                  <div className={"social"}>
                    <a
                      href="https://twitter.com/servit"
                      target={"_blank"}
                      title={"Twitter"}
                    >
                      <img alt={"Twitter"} src={iconTwitter} />
                    </a>
                    <a
                      href="https://twitter.com/servit"
                      target={"_blank"}
                      title={"Twitter"}
                    >
                      <img alt={"Twitter"} src={iconLinkedIn} />
                    </a>
                    <a
                      href="https://www.instagram.com/servit/"
                      target={"_blank"}
                      title={"Instagram"}
                    >
                      <img alt={"Instagram"} src={iconInstagram} />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className={"copyright"}>
              <p>
                Copyright {new Date().getFullYear()}, {` `}{" "}
                <a href="https://servit.com" title={"Servit"}>
                  Servit
                </a>
                . All rights reserved.
              </p>
            </div>
          </div>
        </footer>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
